const MAX_OFFERS = 1500;

export function getTotalPagesCount(perPage: number, aggregatedOffers: number): number {
  return aggregatedOffers <= MAX_OFFERS ? Math.ceil(aggregatedOffers / perPage) : Math.ceil(MAX_OFFERS / perPage);
}
